import React, { useState } from "react";
//MUI
import { Box, Tab, Tabs, TextField } from "@mui/material";

import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import UDataGrid from "./UDataGrid";
import { DataGrid } from "@mui/x-data-grid";
import styled from "@emotion/styled";
import UTable from "../../components/mui/UTable";

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
            children
        )}
      </div>
    );
  };
  
TabPanel.propTypes = {
children: PropTypes.node,
index: PropTypes.number.isRequired,
value: PropTypes.number.isRequired,
};
function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  };

const XTabs = styled(Tabs)({
  minHeight: '45px',
  padding: '0px 0px',
  '& .MuiTabs-indicator': {
    position: 'absolute',
    width: '112px',
    height: '5px',
    left: '1px',
    top: '40x',
    
    background: '#2F2F2F',
    transform: 'matrix(1, 0, 0, -1, 0, 0)',
  },
});

const XTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  p: '0px 20px',
  boxSizing: 'border-box',
  background: '#DDDDDD',
  minHeight: '45px',
  padding: '0px 14px',
  border: '1px solid #DDDDDD',
  borderRadius: '6px 6px 0px 0px',
  marginRight: '5px',
  width: '124px',
  left: '0px',
  borderBottom: '0px',
  textTransform:"none",
  '&.MuiTabs-scroller':{
  },
  '&.Mui-selected': {
    color: '#000000',
    background: '#F6F6F6',
  },
  '&.Mui-focusVisible': {
    backgroundColor: '#d1eaff',
  }, 
  '&:hover': {
    color: '#8D7C57',
    opacity: 1,
  },
}));

const UTabs = (props)=>{
    const children = props.children;
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        props.onChangeTab(newValue);
      };

    return(
        <Box>
                <XTabs value={value} onChange={handleChange} >
                {
                    children.map((child, i)=>
                        <XTab key={i} label={child.props.tablabel} {...a11yProps(i)} />
                    )
                }
                </XTabs>
            {
                children.map((child, i)=>
                    <TabPanel key={i} value={value} index={i} >
                      {/*{child}*/}
                      <UTable columns={child.props.columns} rows={child.props.rows} rowPerPage={child.props.rowPerPage} onSelectedRowChange={child.props.onSelectedRowChange} maxWidth={child.props.maxWidth}/>
                    </TabPanel>
                )
            }
        </Box>
    );
};

export default UTabs;